document.addEventListener('DOMContentLoaded', function () {
  var images = document.querySelectorAll('.magnify');

  images.forEach(function (image) {
    // Create a wrapper div for each image
    var container = document.createElement('div');
    container.classList.add('magnify-container');
    container.style.position = 'relative';
    container.style.display = 'inline-block';
    container.style.overflow = 'hidden';

    // Wrap the image in the container
    image.parentNode.insertBefore(container, image);
    container.appendChild(image);

    // Create the magnifying glass element
    var magnifyGlass = document.createElement('div');
    magnifyGlass.classList.add('magnify-glass');
    container.appendChild(magnifyGlass);

    // Zoom factor
    var zoomFactor = 1.5; // Adjust this for desired zoom

    // Mousemove event for magnifying effect
    image.addEventListener('mousemove', function (event) {
      var imgRect = image.getBoundingClientRect();
      var x = event.clientX - imgRect.left;
      var y = event.clientY - imgRect.top;

      // Ensure mouse is inside the image
      if (x > imgRect.width || x < 0 || y > imgRect.height || y < 0) {
        magnifyGlass.style.visibility = 'hidden';
        return;
      }

      magnifyGlass.style.visibility = 'visible';

      var bgX = -(x * zoomFactor - magnifyGlass.offsetWidth / 2);
      var bgY = -(y * zoomFactor - magnifyGlass.offsetHeight / 2);

      magnifyGlass.style.backgroundImage = 'url(' + image.src + ')';
      magnifyGlass.style.backgroundSize =
        image.width * zoomFactor + 'px ' + image.height * zoomFactor + 'px';
      magnifyGlass.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
      magnifyGlass.style.top = y - magnifyGlass.offsetHeight / 2 + 'px';
      magnifyGlass.style.left = x - magnifyGlass.offsetWidth / 2 + 'px';
    });

    // Hide magnifying glass when mouse leaves the image
    container.addEventListener('mouseleave', function () {
      magnifyGlass.style.visibility = 'hidden';
    });
  });
});
